import React from 'react';
import classNames from 'classnames';

import styles from './MediaSection.module.scss';

const MediaSection = ({ title, className, children }: { title: string; className?: string; children: React.ReactNode }) => {
  return (
    <section className={classNames(styles.section, className)}>
      <h2 className={styles.title}>{title}</h2>
      {children}
    </section>
  );
};

export default MediaSection;
